<template>
  <div class="ly-c-home">
    <!-- <nav-bar title="中国中化决策会议管理平台"></nav-bar> -->

    <el-container style="height: 100vh">
      <side-bar @logout="userLogout"></side-bar>
      <el-container class="ly-c-container">
        <div class="top">
          <div class="title">
            中国中化职能管控一体化平台 - 中化财务信息披露系统
          </div>
          <el-dropdown class="info" trigger="click">
            <span class="el-dropdown-link">
              {{ userInfo.name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="userLogout"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <div class="info">
            
          </div> -->
        </div>
        <tab-views
          v-if="!$route.meta || !$route.meta.noTagView"
          :defaultTags="defaultTags"
        ></tab-views>
        <!-- <breadcrumb v-if="!$route.meta.noTagView"></breadcrumb> -->
        <el-main>
          <el-scrollbar
            class="ly-c-scroll ly-c-full-screen"
            style="height: 100%"
          >
            <div class="main-content scrollbar">
              <keep-alive v-if="isRouterAlive">
                <router-view
                  v-if="$route.meta.keepAlive"
                  @query="routeQuery"
                ></router-view>
              </keep-alive>
              <router-view
                v-if="!$route.meta.keepAlive && isRouterAlive"
                @query="routeQuery"
              ></router-view>
            </div>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import {
  SideBar,
  NavBar,
  Breadcrumb,
  Bus,
  auth,
  TabViews,
  request,
} from "common";
import { logout } from "@/api/login";
export default {
  components: {
    SideBar,
    NavBar,
    Breadcrumb,
    TabViews,
  },
  data() {
    return {
      isRouterAlive: true,
      userInfo: "",
      defaultTags: [],
    };
  },
  watch: {},
  created() {
    this.userInfo = auth.getUserInfo();
  },
  methods: {
    userLogout() {
      request({
        url: "/auth/oauth/logout",
        method: "get",
      }).then((res) => {
        if (res.code === "00000") {
          // auth.removeAllSession();
          // auth.goLogin();
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
    routeQuery(data) {
      Bus.$emit("getQueryInfo", data);
    },
    userLogout() {
      logout().then((res) => {
        if (res.code === "00000") {
          auth.loginOut();
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #09203A;
  letter-spacing: 0;
  font-weight: 600;
}
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  height: 47px;
  line-height: 47px;
  background-color: #fff;
  border-bottom: 1px solid rgba(229, 232, 239, 1);
  .info {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    height: 36px;
    background-image: linear-gradient(90deg, #dce7f2 4%, #eaf1f7 100%);
    border-radius: 100px 6px 6px 100px;
    color: #02111d;
    cursor: pointer;
  }
}
.ly-c-home {
  height: 100vh;
  background: $home_content;
  .ly-c-container {
    // overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0 0 0 4px;
    flex-grow: 1 !important;
    flex-basis: 0 !important;
    /deep/.el-main {
      padding: 0;
      flex-basis: 0;
    }
    /deep/ .ly-c-full-screen {
      > .el-scrollbar__wrap {
        > .el-scrollbar__view {
          height: 100%;
          //min-height: 100%;
          .main-content {
            height: 100%;
            & > div {
              display: flex;
              flex-direction: column;
              min-height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
